// src/js/components/bundle-product-button.js
var BundleproductButton = class extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".bundle-button--off");
    this.checkUrl();
    this.init();
  }
  checkUrl() {
    setTimeout(() => {
      const url = new URL(window.location.href);
      const isBundleTrue = url.searchParams.get("bundle") === "true";
      if (isBundleTrue) {
        this.button?.classList.add("active");
        this.updateForm();
      } else {
        if (this.button.classList.contains("active")) {
          this.button?.classList.remove("active");
        }
      }
    }, 500);
  }
  init() {
    this.button?.addEventListener("click", () => {
      if (!this.button.classList.contains("active")) {
        this.button.classList.add("active");
      }
      this.updateUrl();
      this.updateForm();
    });
  }
  updateUrl() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("bundle")) {
      url.search = "?bundle=true";
      window.history.replaceState(null, null, url);
    }
  }
  updateForm() {
    const bundleWrapper = document.querySelector(".book-bundle-info-wrapper-main");
    if (bundleWrapper && !bundleWrapper.classList.contains("active")) {
      bundleWrapper.classList.add("active");
    }
    const form = document.querySelector("product-form form");
    const inputId = form?.querySelector(".product-variant-id");
    const buttonForm = form?.querySelector(".product-form__submit");
    const priceBundleTag = this.querySelector(".price-bundle-tag");
    const priceMainTag = document.querySelector(".price--main-product");
    priceMainTag.innerHTML = priceBundleTag.innerHTML;
    if (buttonForm?.disabled) {
      buttonForm.disabled = false;
    }
    setTimeout(() => {
      inputId.value = this.button.dataset.id;
    }, 10);
    this.uncheckAll();
  }
  uncheckAll() {
    const variantSelects = document.querySelector("variant-selects");
    const inputs = variantSelects?.querySelectorAll("input");
    inputs?.forEach((el) => {
      el.checked = false;
    });
  }
};
customElements.define("bundle-product-button", BundleproductButton);
